import React from 'react';
import { Form } from 'react-final-form';
import { Box, lighten } from '@mui/material';

import { ConfirmDialog, LinearProgress, Link, Typography } from '@occc/ui-design-system';

import { LocationGroupSelect } from './LocationGroupSelect';
import { AddToLocationGroupDialogFormValues } from './types';

interface AddToLocationGroupDialog {
  open: boolean;
  onClose: () => void;
  onCreateNewGroupClick: () => void;
  onSubmit: (values: AddToLocationGroupDialogFormValues) => Promise<void>;
  loading: boolean;
}

export const AddToLocationGroupDialog: React.FC<AddToLocationGroupDialog> = ({
  open,
  onClose,
  onCreateNewGroupClick,
  onSubmit,
  loading,
}) => {
  const renderForm = () => (
    <>
      <Typography variant='subtitle1'>
        Select a location group where you would like to add selected location
      </Typography>

      {loading && <LinearProgress />}

      <Box mt={3}>
        <LocationGroupSelect />
      </Box>

      <Box
        p={2}
        mt={1}
        borderRadius={1}
        sx={({ palette }) => ({ background: lighten(palette.primary.main, 0.9) })}
      >
        <Typography>
          Or you can add this location to a{' '}
          <Link
            component='span'
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              onClose();
              onCreateNewGroupClick();
            }}
          >
            New Location Group
          </Link>
        </Typography>
      </Box>
    </>
  );

  return (
    <Form<AddToLocationGroupDialogFormValues>
      onSubmit={onSubmit}
      render={({ handleSubmit, values }) => (
        <ConfirmDialog
          confirmButtonText='Add to a group'
          confirmButtonProps={{
            onClick: handleSubmit,
            disabled: !values.locationGroup?.uuid || loading,
          }}
          dialogTitle='Add location to a location group'
          open={open}
          onClose={onClose}
        >
          {renderForm()}
        </ConfirmDialog>
      )}
    />
  );
};
